<template>
  <div class="zj-emergency-task-list select-none">
    <div>
      <div>采用预案：{{ this.planName }}</div>
      <div class="detail-btn" @click="viewDetail">详情</div>
    </div>
    <el-tabs class="custom-tabs child-tabs" v-model="activeName">
      <el-tab-pane label="全部任务" name="first">
        <el-table :data="tableData" :show-header="false" stripe="false">
          <el-table-column>
            <template slot-scope="scope">
              <div class="task-row select-none">
                <div :class="statusClass(scope.row)">
                  {{ convertStatus(scope.row) }}
                </div>
                <div class="detail">
                  <div>
                    {{ scope.$index + 1 }}.{{
                      scope.row.TaskTiltle + scope.row.TaskDesc
                    }}
                  </div>
                </div>
                <div
                  class="btn-start"
                  @click="handleStart(scope.row)"
                  v-if="convertStatus(scope.row) !== '已完成'"
                >
                  启动
                </div>
                <div
                  class="btn-close"
                  @click="handleClose(scope.row)"
                  v-if="scope.row.TaskStatus !== '4'"
                >
                  关闭
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="异常任务" name="second">
        <el-table
          :data="exceptionTask"
          @row-click="rowclick"
          :show-header="false"
        >
          <el-table-column>
            <template slot-scope="scope">
              <div class="task-row select-none">
                <div :class="statusClass(scope.row)">
                  {{ convertStatus(scope.row) }}
                </div>
                <div class="detail">
                  <div>
                    {{ scope.$index + 1 }}.{{
                      scope.row.TaskTiltle + scope.row.TaskDesc
                    }}
                  </div>
                </div>
                <div class="btn-start" @click="handleStart(scope.row)">
                  启动
                </div>
                <div class="btn-close" @click="handleClose(scope.row)">
                  关闭
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      class="onemap-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isVisiable"
    >
      <PlanDetail v-bind:query="{ obj: this.planId, type: 'search' }" />
    </el-dialog>
    <el-dialog
      class="emergencyoperations-dialog thin"
      custom-class="bg2"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isFeedbackVisiable"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
    >
      <Feedback
        @handlerclose="isFeedbackVisiable = false"
        v-bind:currentTask="currentTask"
      />
    </el-dialog>
  </div>
</template>
<script>
import Constant from "../config/constant";

import PlanDetail from "./../../Plan/PlanManage";
import Feedback from "./Component-TaskFeedback";

export default {
  name: "ZJEmergencyComponentTaskList",
  componentName: "ZJEmergencyComponentTaskList",
  components: {
    PlanDetail: PlanDetail,
    Feedback: Feedback,
  },
  props: {
    tableData: {
      type: Object,
      default: function () {
        return [];
      },
    },
    planName: String,
    planId: String,
  },
  data() {
    return {
      startTaskMsgKey: "MessageKey_EmergencyEventStartTask",
      activeName: "first",
      isVisiable: false,
      isFeedbackVisiable: false,
      currentTask: {},
    };
  },
  methods: {
    statusClass: function (row) {
      return {
        processing:
          row.TaskStatus == Constant.TaskStatus.Processing.desc ||
          row.TaskStatus == Constant.TaskStatus.Processing.code ||
          row.TaskStatus == Constant.TaskStatus.Exception.desc ||
          row.TaskStatus == Constant.TaskStatus.Exception.code,
        todo:
          row.TaskStatus == Constant.TaskStatus.Todo.desc ||
          row.TaskStatus == Constant.TaskStatus.Todo.code,
        finished:
          row.TaskStatus == Constant.TaskStatus.Done.desc ||
          row.TaskStatus == Constant.TaskStatus.Done.code ||
          row.TaskStatus == Constant.TaskStatus.Closed.desc ||
          row.TaskStatus == Constant.TaskStatus.Closed.code,
      };
    },
    convertStatus: function (row) {
      var status = "";
      if (
        row.TaskStatus == Constant.TaskStatus.Todo.desc ||
        row.TaskStatus == Constant.TaskStatus.Todo.code ||
        row.TaskStatus == Constant.TaskStatus.Processing.desc ||
        row.TaskStatus == Constant.TaskStatus.Processing.code
      ) {
        status = "执行中";
      } else if (
        row.TaskStatus == Constant.TaskStatus.Done.desc ||
        row.TaskStatus == Constant.TaskStatus.Done.code ||
        row.TaskStatus == Constant.TaskStatus.Closed.desc ||
        row.TaskStatus == Constant.TaskStatus.Closed.code
      ) {
        status = "已完成";
      } else {
        status = "启动失败";
      }
      return status;
    },
    // eslint-disable-next-line no-unused-vars
    handleStart: function (row) {
      var msgcontent = {
        key: this.startTaskMsgKey,
        data: row.ExecutTaskId,
      };
      this.$notify.broadcase(msgcontent);
      this.$message({ message: "任务已启动", type: "success" });
    },
    // eslint-disable-next-line no-unused-vars
    handleClose: function (row) {
      this.currentTask = JSON.parse(JSON.stringify(row));
      this.isFeedbackVisiable = true;
    },
    // eslint-disable-next-line no-unused-vars
    viewDetail: function () {
      this.isVisiable = true;
    },
  },
  computed: {
    exceptionTask: function () {
      var result = this.tableData.filter(function (item) {
        return (
          item.TaskStatus == Constant.TaskStatus.Exception.desc ||
          item.TaskStatus == Constant.TaskStatus.Exception.code
        );
      });
      return result;
    },
  },
  watch: {},
};
</script>